<ng-container *ngIf="electricMeter">
    <ng-container *ngIf="disableLink; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Lagerplatz kann nicht identifiziert werden!">
                    <em>Kein Name</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           [bcmRouterLink]="linkToReadings ? ['electric-meters', electricMeter.id, 'readings'] : ['electric-meters', electricMeter.id]">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Lagerplatz kann nicht identifiziert werden!">
                    <em>Kein Name</em>
                </abbr>
            </ng-template>
        </a>
    </ng-template>
</ng-container>
